import { GradingScheme } from 'app/library/grading-scheme/models/grading-scheme.model';

export class UpdateGradeCalculationSuccess {
    static readonly type = '[GradingScheme] UpdateGradeCalculationSuccess';

    constructor(
        public payload: {
            gradingScheme: GradingScheme;
        }
    ) {}
}
